<template>
    <div>
        <hts-form-select
            v-model="cValue"
            v-model:text="cText"
            :query="findCommodity"
            :filterable="true"
            :clearable="true"
            :creatable="CCreatable"
            :label="$t('labels.commodity')"
            :required="required"
            :multiple="multiple"
            :prop="prop"
            :selected-multiple="dataSelectMultiple"
            key-id="_id"
            key-label="commodity"
            @create-new="openAddCommodity" />
        <add-commodity ref="addCommodity" />
    </div>
</template>

<script lang="ts" setup>
import AddCommodity from '../../pages/trucker-[id]/partner/[idpartner]/commodity/-components/add-commodity.vue'
import layoutPermissions from '@/data/permissions/layout-permissions'
import { checkPermission } from '@/utils/permission-check'
const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  dataSelectMultiple: { type: Array, default: () => [] },
  prop: { type: String },
  multiple: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
  creatable: { type: Boolean, default: false },
  cooperatorId: { type: String, default: '' },
  name: { type: String, default: '' },
  functionCreateNew: { type: Function, default: null }
})

const emits = defineEmits(['update:modelValue', 'update:name', 'click'])

const CCreatable = computed(() => {
  if (!creatable?.value) {
    return false
  }
  if (!checkPermission(layoutPermissions.partner_commodity_add)) {
    return false
  }
  return true
})

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const cText = computed({
  get () {
    return name.value || ''
  },
  set (val: any) {
    emits('update:name', val)
  }
})
const { modelValue, cooperatorId, creatable, functionCreateNew, name } = toRefs(props)
const findCommodity = async (s: string) => {
  const api = $url.commodity.commodity.find
  const res = await $api(api, { uriParams: { KEY: s, COOPERATOR: cooperatorId.value } })
  const resData: any = res?.data.value
  if (resData?.success) {
    return resData.data
  }
  return null
}
// const handleAddCommodity = () => {
//   if (creatable && functionCreateNew.value && typeof functionCreateNew.value === 'function') {
//     functionCreateNew.value()
//   }
// }

const addCommodity = ref()
const openAddCommodity = () => {
  if (addCommodity.value) {
    addCommodity.value.open(cooperatorId.value)
  }
}
</script>
